export default __webpack_public_path__ + "static/media/num-icon-bg.1413ed54.png";